import React from 'react';

const FontSizeButton = ({
  active,
  label,
  onToggle,
  fontSize,
  positionStyle,
  size = '32px'
}) => {
  return (
    <div
      onClick={() => onToggle(fontSize)}
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        border: active ? '2px solid #1890ff' : '1px solid #d9d9d9',
        borderRadius: '4px',
        backgroundColor: active ? '#e6f7ff' : 'white',
        fontSize: '14px',
        fontFamily: 'monospace',
        fontWeight: active ? 'bold' : 'normal',
        ...positionStyle,
      }}
      title={label}
    >
      {fontSize}
    </div>
  );
};

export default FontSizeButton;
